'use client';

import { WithdrawalGuideContent } from '@features/withdrawal-guide';
import { observer } from 'mobx-react-lite';

import { ModalWrapper } from '@/shared/ui';
import { useStore } from '@/store/context';

import styles from './styles.module.scss';

export const WithdrawalGuideModalDesktop = observer(() => {
  const withdrawalStore = useStore().withdrawal;

  const handleCLose = () => {
    withdrawalStore.setGuideStep(null);
    withdrawalStore.setSelectedTrade(withdrawalStore.trades[0].id);
  };

  return (
    <ModalWrapper
      close={handleCLose}
      className={styles.modal}
      isOpened={!!withdrawalStore.guideStep}
      isMobile={false}
    >
      <WithdrawalGuideContent
        step={withdrawalStore.guideStep}
        onClose={handleCLose}
      />
    </ModalWrapper>
  );
});
